export default "__VITE_ASSET__B7OBEtS5__"